import { IOptionService } from '../interfaces/option-service.interface';
import { FieldOption } from '../types/validation-types';

/**
 * No-Op OptionService für Apps ohne Feld-Konfigurationen.
 */
export class NullOptionService implements IOptionService {
	option(_key: string): FieldOption | undefined { return undefined; }
}
